






































































































import mixin from './mixin'

import moment from 'moment'

import { Query } from '../../types/data-log'
import { BSTableField } from './types'

import { QueryRecordedData } from '@/api/data-logger'
import { mapState } from 'vuex'

const excel = require('@/utils/Export2Excel')

export default mixin.extend({
  data() {
    return {
      form: {
        limit: 50,
        currentPage: 1,
        rowsCount: 0,
        elDatePicker: [0, 0],
      },

      statusBusy: false,

      statusData: {
        dataLogger: '',
        startTime: '',
        endTime: '',
      },
      // eslint-disable-next-line
      items: [] as any[],

      optsLimit: [50, 100, 200, 250, 500, 1000],
    }
  },

  computed: {
    ...mapState('tag', { tags: 'items' }),
    fields(): BSTableField[] {
      const fields: BSTableField[] = [
        {
          key: 'n',
          label: '#',
          class: 'text-center',
          thStyle: { width: '20px' },
        },
        { key: 'time', label: 'Timestamp' },
      ]

      for (const item of this.dataLoggerItems) {
        const tag = this.tags[item.tagUID]
        if (tag.attributes && tag.attributes.hideFromTable) {
          continue
        }
        fields.push({ key: item.tagUID, label: item.name })
      }

      return fields
    },
  },

  methods: {
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Initialization
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    initForm() {
      // set default picker
      const cDate = moment().format('YYYY-MM-DD')
      this.form.elDatePicker[0] = moment(cDate).valueOf()
      this.form.elDatePicker[1] = moment().valueOf()
    },

    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Recorded data operation
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    async queryRecordedData(q: Query) {
      this.items = []

      const Results = await QueryRecordedData([q])

      if (Results.length < 1) {
        return
      }

      const results = Results[0]

      if (results.length < 2) {
        this.form.rowsCount = 0
        return
      }

      // Series pertama adalah data
      const dataResult = results[0]
      // Series terakhir adalah jumlah record
      const countResult = results[1]

      if (!Array.isArray(dataResult.Series)) {
        this.form.rowsCount = 0
        return
      }

      if (!Array.isArray(countResult.Series)) {
        this.form.rowsCount = 0
        return
      }
      if (countResult.Series.length > 0) {
        this.form.rowsCount = countResult.Series[0].values[0][1]
      }

      const seriesCount = dataResult.Series.length
      if (seriesCount < 1) return

      const valuesCount = dataResult.Series[0].values.length
      const columns = dataResult.Series[0].columns

      const series = dataResult.Series[0]

      for (let valueIndex = 0; valueIndex < valuesCount; valueIndex++) {
        // eslint-disable-next-line
        let row: any = {
          n: valueIndex + 1 + (q.offset || 0),
        }

        for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
          const columnName = columns[columnIndex]
          if (columnName == 'time') {
            row.time = moment(
              dataResult.Series[0].values[valueIndex][0]
            ).format('YYYY-MM-DD HH:mm:ss')
            continue
          }

          row[columnName] = series.values[valueIndex][columnIndex]
        }

        this.items.push(row)
      }
    },

    async readRecord() {
      if (this.dataLoggerId == -1) {
        return
      }

      this.statusBusy = true
      this.statusData = {
        dataLogger: '',
        startTime: '',
        endTime: '',
      }

      try {
        const timeStart = moment(this.form.elDatePicker[0]).toDate()
        const timeEnd = moment(this.form.elDatePicker[1] - 1).toDate()

        const fields: string[] = []
        for (let i = 2; i < this.fields.length; i++) {
          fields.push(this.fields[i].key)
        }

        const q: Query = {
          dataLoggerId: this.dataLoggerId,
          timeStart,
          timeEnd,
          fields,
          limit: this.form.limit,
          offset: (this.form.currentPage - 1) * this.form.limit,
        }

        await this.queryRecordedData(q)

        const dl = this.optsDataLogger.find(
          (d) => d.value == this.dataLoggerId.toString()
        )

        // Set status data agar informasi pada tabel lebih tepat
        if (dl) {
          const timeFormat = 'd MMM yyyy HH:mm:ss'
          this.statusData = {
            dataLogger: dl.text,
            startTime: moment(timeStart).format(timeFormat),
            endTime: moment(timeStart).format(timeFormat),
          }
        }
      } catch {
        this.$toast.error('Failed to read recorded data.')
      }
      this.statusBusy = false
    },

    //---------------------------------------------------------------------------------------------------------------------------
    // Toolbar events
    //---------------------------------------------------------------------------------------------------------------------------
    async onToolbarShow() {
      await this.readRecord()
    },

    onToolbarExport() {
      const fileName = `Export ${this.statusData.dataLogger} from  ${this.statusData.startTime} to  ${this.statusData.endTime} `
      // eslint-disable-next-line
      const headers = {} as any
      for (const i in this.fields) {
        const field = this.fields[i]
        headers[field.key] = field.label
      }
      excel.json2excel(fileName, this.items, headers)
    },

    // eslint-disable-next-line
    readableValue(v: any): any {
      if (typeof v == 'number') {
        if (v % 1 == 0) {
          return v
        }
        return v.toFixed(3)
      }

      return v
    },
  },

  watch: {
    dataLoggerId: function() {
      this.items = []
      this.form.rowsCount = 0
    },

    'form.currentPage': async function() {
      await this.readRecord()
    },
    'form.limit': async function() {
      await this.readRecord()
    },
  },

  created() {
    this.initForm()
  },
})
